import FlockStatusInvoice from './FlockStatusInvoice';

export default FlockStatusInvoice;
